package com.tovtalk.di

import org.koin.core.Koin
import org.koin.core.context.GlobalContext

actual fun getKoin(): Koin = GlobalContext.get()
